module.exports = __webpack_public_path__ + "img/19.cc9a1e1b.webp";